export enum FeatureToggle {
  MultiFactorAuth = 'rt_ipp_mfa_users_allowlist',
  EnableMfaManagementForRetailer = 'rt_enable_mfa_management_for_retailer',
  MfaModalDisplay = 'rt_mfa_modal_display_users_allowlist',
}
